import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  labelRoot: {
    display: "flex",
    alignItems: "bottom",
    userSelect: "none",
  },
}));

function ClickAndDoubleClick(props) {
  const classes = useStyles();
  const delay = 180;
  let timer = null;
  let prevent = false;

  return (
    <>
      <div
        className={classes.labelRoot}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          timer = setTimeout(() => {
            if (!prevent) {
              props.onClick && props.onClick(props.node, e);
            }
          }, delay);
        }}
        onDoubleClick={(e) => {
          prevent = true;
          e.preventDefault();
          clearTimeout(timer);
          setTimeout(() => {
            prevent = false;
          }, delay);
          props.onDoubleClick && props.onDoubleClick(props.node, e);
        }}
      >
        {props.children}
      </div>
    </>
  );
}

export default ClickAndDoubleClick;
